import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import UserSlice from './slices/User';
import MainMenuSlice from './slices/MainMenu';
import ListsSlice from './slices/Lists';
import NotificationCountSlice from './slices/NotificationCount';

export const store = configureStore({
	reducer: {
		user: UserSlice.reducer,
		mainMenu: MainMenuSlice.reducer,
		lists: ListsSlice.reducer,
		notificationCount: NotificationCountSlice.reducer
	}
});

// Infer the `StateType` (RootState) and `DispatchType` (AppDispatch) types from the store itself
export type StateType = ReturnType<typeof store.getState>;
export type DispatchType = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<DispatchType>();
export const useAppSelector: TypedUseSelectorHook<StateType> = useSelector;
